import { useNavigate, useSearch } from '@tanstack/react-router';

import {
  parseIntegrationsRouteSearch,
  serializeIntegrationsRouteSearch,
} from './integrationsRouteSearch';
import type { IntegrationSortDirection, IntegrationSortProperty, IntegrationStatus } from './model';

export function useIntegrationsRouteFilters() {
  const navigate = useNavigate({ from: '/demand/integrations/' });
  const search = useSearch({ from: '/demand/integrations/' });
  const filter = parseIntegrationsRouteSearch(search);
  const update = (next: typeof filter) => {
    void navigate({ search: serializeIntegrationsRouteSearch(next), replace: true });
  };

  return {
    filter,
    setSearch: (searchTerm: string) => {
      update({ ...filter, searchTerm, page: 0 });
    },
    setStatuses: (statuses: IntegrationStatus[]) => {
      update({ ...filter, statuses, page: 0 });
    },
    setSort: (
      sortProperty: IntegrationSortProperty | null,
      sortDirection: IntegrationSortDirection,
    ) => {
      update({ ...filter, sortProperty, sortDirection, page: 0 });
    },
    setPagination: (page: number, size: number) => {
      update({ ...filter, page: size === filter.size ? page : 0, size });
    },
  };
}
